'use strict';

(function () {
  'use strict';

  angular.module('vnext').directive('msSkipToContentButton', msSkipToContentButton);

  msSkipToContentButton.$inject = ['$window', '$log', '$timeout'];

  /* @ngInject */
  function msSkipToContentButton($window, $log, $timeout) {
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attrs) {
      element.on('click keyup', function (event) {
        // 13 == 'enter'
        // Allow the user to press "enter" to activiate this button.
        if (event.keyCode && event.keyCode !== 13) {
          return;
        }
        $timeout(function () {
          var targetElement = $window.document.getElementById(attrs.target);
          if (targetElement) {
            targetElement.focus();
          }
        });
      });
    }
  }
})();